import { render, staticRenderFns } from "./sent-to-educator.vue?vue&type=template&id=e55165fa&scoped=true&"
import script from "./sent-to-educator.vue?vue&type=script&lang=js&"
export * from "./sent-to-educator.vue?vue&type=script&lang=js&"
import style0 from "./sent-to-educator.vue?vue&type=style&index=0&id=e55165fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55165fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
